import some from 'lodash/some';
import every from 'lodash/every';
import $ from 'jquery';

export const isElementInScope = (scopeSelectors = [], targetElement) => {
	const $targetEl = $(targetElement);

	return some(scopeSelectors, (selector) => {
		return $targetEl.is(selector) || !!$targetEl.closest(selector).length;
	});
};

export const isContainElement = (innerSelectors = [], targetElement) => {
	const $targetEl = $(targetElement);

	return some(innerSelectors, (selector) => {
		return !!$targetEl.find(selector).length;
	});
};

export const isIncludeAllElements = (innerSelectors = [], targetElement) => {
	const $targetEl = $(targetElement);

	return every(innerSelectors, (selector) => {
		return !!$targetEl.find(selector).length;
	});
};
